import { render, staticRenderFns } from "./_common_right.vue?vue&type=template&id=2a0af6c8"
import script from "./_common_right.vue?vue&type=script&lang=js"
export * from "./_common_right.vue?vue&type=script&lang=js"
import style0 from "./_common_right.vue?vue&type=style&index=0&id=2a0af6c8&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a0af6c8')) {
      api.createRecord('2a0af6c8', component.options)
    } else {
      api.reload('2a0af6c8', component.options)
    }
    module.hot.accept("./_common_right.vue?vue&type=template&id=2a0af6c8", function () {
      api.rerender('2a0af6c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/_common_right.vue"
export default component.exports